export interface State {}

export interface Context {
  commit: (name: string, payload: object) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {}

export const mutations: Mutations = {}
export const actions: Actions = {
  async fetchTwitterUrl() {
    const { response, error } = await this.$api.fetchTwitterUrl()
    // window.open(response.authorization_url, 'twitterWindow', 'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1')
    window.location.href = response.authorization_url
  },
  async disconnectTwitter() {
    const { response, error } = await this.$api.postDisconnectTwitter()
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  actions,
  mutations
}
